import type { TwitterSourceValue } from '../types';

export const twitterExcludeFiltersKeys: {
  [K in keyof TwitterSourceValue]?: string;
} = {
  showReplies: 'reply',
  showReposts: 'repost',
  showPosts: 'common'
};
